import { createReducer } from '@reduxjs/toolkit';
import { type StoreAppState } from '../types/StoreState';
import { checkApCanMakePayments } from '../actions/checkApCanMakePayments';
import { checkApHighestSupportedVersion } from '../actions/checkApHighestSupportedVersion';
import { loadExperiments } from '../actions/loadExperiments';
import { setSessionId } from '../actions/setSessionId';
import { loadPayPalScript } from '../actions/loadPayPalScript';
import { getPayPalMethodsEligibility } from '../services/paypal/getPayPalMethodsEligibility';

// @ts-expect-error
const initialState: StoreAppState = {};

export const appStateReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loadPayPalScript.fulfilled, (state) => {
      state.payPalMethodsEligibility = getPayPalMethodsEligibility();
    })
    .addCase(checkApCanMakePayments.fulfilled, (state, action) => {
      state.applePayCanMakePayments = action.payload;
    })
    .addCase(checkApCanMakePayments.rejected, (state, action) => {
      state.applePayCanMakePayments = action.payload;
    })
    .addCase(checkApHighestSupportedVersion.fulfilled, (state, action) => {
      state.highestSupportedApplePayVersion = action.payload;
    })
    .addCase(checkApHighestSupportedVersion.rejected, (state, action) => {
      state.highestSupportedApplePayVersion = action.payload;
    })
    .addCase(loadExperiments, (state, action) => {
      state.experiments = action.payload;
    })
    .addCase(setSessionId, (state, action) => {
      state.sessionId = action.payload;
    });
});
